import {
  Drawer as CDrawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerContentProps,
  DrawerHeader,
  DrawerProps,
} from '@chakra-ui/react';
import { RefObject } from 'react';

interface Props extends DrawerProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  // Adding contentProps in order to customize the width of Drawer because size props has some bugs.
  contentProps?: DrawerContentProps;
  ref?: RefObject<HTMLInputElement>;
  children: React.ReactNode;
  contentTrackId?: string;
}

export const Drawer: React.FC<Props> = ({
  isOpen,
  title,
  onClose,
  contentProps,
  ref,
  children,
  contentTrackId,
  ...props
}) => {
  return (
    <CDrawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      finalFocusRef={ref}
      blockScrollOnMount={false}
      {...props}
    >
      <DrawerContent {...contentProps} track-id={contentTrackId}>
        <DrawerCloseButton />
        <DrawerHeader color="primary.700" fontSize="3xl">
          {title}
        </DrawerHeader>
        {children}
      </DrawerContent>
    </CDrawer>
  );
};
